import './Input.less'
import React, { PureComponent } from 'react'
import classNames from 'classnames'
import { Input as AntInput } from 'antd'
import InputTextArea from './InputTextArea'

const { Search, Group } = AntInput

export default class Input extends PureComponent {
  render() {
    const { className, v2, ...others } = this.props
    const InputClassName = classNames('pan-input', className, v2 ? 'pan-input-border-v2' : '')
    const InputProps = {
      className: InputClassName
    }
    return <AntInput ref={ref => {
      this.inputRef = ref
    }} {...others } {...InputProps} />
  }
}

Input.TextArea = InputTextArea
Input.Search = Search
Input.Group = Group
Input.AntInput = AntInput
